@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../constants/spacing.module.less';

.shipfrom-contact-wrapper {
  min-width: 65%;
}

.shipfrom-contact-dropdown {
  align-items: flex-start;
  display: flex;
  gap: @space-12;
  width: 100%;
  height: 35px;
}

.title {
  min-width: 200px;
}

.subtitle {
  margin-top: 3px;
  font-size: x-small;
  color: @carrier-pickup--modal-subtitle--text-color;
}

.manage-shipfrom-contact-button {
  border: 1px solid @carrier-pickup--manage-shipfrom-contacts-button--border-color;
  padding: 0;
  height: 100%;
  .manage-shipfrom-contact-icon {
    fill: @carrier-pickup--manage-shipfrom-contacts-button--fill-color;
    padding: 6px;
    margin: 2px 0;
  }
}
